import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS } from "@/lib/constants";
import { useReveal } from "@/hooks/use-reveal";

export default function ContactMap() {
  const r = useReveal();
  return (
    <section className="py-20 sm:py-24 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={r.ref} className={r.className}>
          <div className="grid lg:grid-cols-2 gap-8 items-stretch">
            <div className="bg-white rounded-3xl border border-[#E2E8F0] p-8 shadow-sm">
              <span className="text-sm font-semibold uppercase tracking-widest text-[#0E7490]">Visit Us</span>
              <h2 className="mt-2 font-display text-3xl sm:text-4xl font-bold text-[#111827]">Find our counter</h2>

              <div className="mt-6 space-y-4">
                <div className="flex gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#0057B8]/10 text-[#0057B8] grid place-items-center shrink-0"><MapPin className="w-5 h-5" /></div>
                  <div>
                    <div className="font-semibold text-[#111827]">Address</div>
                    <div className="text-[#6B7280]">{BUSINESS.address}</div>
                  </div>
                </div>
                <div className="flex gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#0057B8]/10 text-[#0057B8] grid place-items-center shrink-0"><Phone className="w-5 h-5" /></div>
                  <div>
                    <div className="font-semibold text-[#111827]">Phone</div>
                    <a href={`tel:${BUSINESS.phone}`} className="text-[#0057B8] hover:underline">{BUSINESS.phoneDisplay}</a>
                  </div>
                </div>
                <div className="flex gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#0057B8]/10 text-[#0057B8] grid place-items-center shrink-0"><Mail className="w-5 h-5" /></div>
                  <div>
                    <div className="font-semibold text-[#111827]">Email</div>
                    <a href={`mailto:${BUSINESS.email}`} className="text-[#0057B8] hover:underline">{BUSINESS.email}</a>
                  </div>
                </div>
                <div className="flex gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#0057B8]/10 text-[#0057B8] grid place-items-center shrink-0"><Clock className="w-5 h-5" /></div>
                  <div>
                    <div className="font-semibold text-[#111827]">Hours</div>
                    <ul className="text-[#6B7280] text-sm space-y-0.5">
                      {BUSINESS.hours.map(h => <li key={h.day}><span className="font-medium text-[#111827]">{h.day}:</span> {h.time}</li>)}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <Button asChild className="bg-[#0057B8] hover:bg-[#003F87] text-white rounded-full btn-brand">
                  <a href={BUSINESS.directionsLink} target="_blank" rel="noreferrer" data-testid="contact-directions-btn">
                    Get Directions <ExternalLink className="w-4 h-4 ml-1.5" />
                  </a>
                </Button>
                <Button asChild variant="outline" className="border-[#0057B8] text-[#0057B8] hover:bg-[#0057B8] hover:text-white rounded-full btn-brand">
                  <a href={BUSINESS.mapsLink} target="_blank" rel="noreferrer" data-testid="contact-view-listing-btn">
                    View on Google
                  </a>
                </Button>
                <Button asChild variant="outline" className="border-[#0057B8] text-[#0057B8] hover:bg-[#0057B8] hover:text-white rounded-full btn-brand">
                  <a href={`tel:${BUSINESS.phone}`}><Phone className="w-4 h-4 mr-1.5" /> Call</a>
                </Button>
              </div>
            </div>

            <div className="rounded-3xl overflow-hidden border border-[#E2E8F0] shadow-sm bg-white min-h-[420px]">
              <iframe
                src={BUSINESS.mapEmbed}
                title="Map to Fastag CSP Bally Toll"
                width="100%"
                height="100%"
                style={{ minHeight: 420, border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
